var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M12.3979 9.92404L8.39795 12.1059",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3981 12.1065L9.93442 19.0872C10.1109 19.8888 10.7591 20.5012 11.5695 20.6318C12.3798 20.7623 13.1876 20.3846 13.6069 19.679L21.0342 7.17994C21.4015 6.56182 21.4088 5.79409 21.0532 5.16914C20.6976 4.54418 20.0339 4.15821 19.3149 4.1582H5.32189C4.51469 4.15818 3.78661 4.64339 3.47592 5.3884C3.16523 6.13342 3.33284 6.99216 3.90089 7.56565L8.3981 12.1065Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.6c86c6d5dcfb038121c1cf9a74ed9217.svg";
export { ForwardRef as ReactComponent };